import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

export const LabelContainer = styled(Box)`
  display: inline-flex;
  align-items: center;
  line-height: 1.2;
`;

export const IconWrapper = styled('span')`
  font-size: 0.82em;
  margin-right: 4px;
`;

export const SlotGridItem = styled(Grid)`
  display: flex;
  pointer-events: none; // disable cell clicks

  & > * {
    pointer-events: auto; // enable only checkbox component
  }
`;

export const ConfirmButtonBox = styled(Box)`
  margin: 8px;
  position: relative;
  left: 24px;
`;

export const InfoIcon = styled('abbr')`
  margin-left: 4px;
  text-decoration: none;
`;
